import { Theme } from "sprint-common-web";

import { AssetType } from "../../../common/types/AssetType";
import { OrderAssetAvailability } from "../types/OrderAssetAvailability";
import { OrderAssetStorageType } from "../types/OrderAssetStorageType";

export const getAvailabilityColor = (isAvailable?: boolean, type?: AssetType): string =>
    isAvailable
        ? type === AssetType.OnPrem
            ? Theme.palette.blue
            : Theme.palette.greenLight
        : Theme.palette.neutralTertiary;

export const getCloudAvailabilityColor = (isAvailable?: boolean): string =>
    getAvailabilityColor(isAvailable, AssetType.Cloud);
export const getOnPremAvailabilityColor = (isAvailable?: boolean): string =>
    getAvailabilityColor(isAvailable, AssetType.OnPrem);

export const orderAssetAvailabilityColorMaps = {
    [OrderAssetStorageType.Cloud]: {
        [OrderAssetAvailability.FullMatch]: Theme.palette.greenLight,
        [OrderAssetAvailability.PartialMatch]: Theme.palette.greenLight,
        [OrderAssetAvailability.NoMatch]: Theme.palette.neutralTertiary
    },
    [OrderAssetStorageType.OnPrem]: {
        [OrderAssetAvailability.FullMatch]: Theme.palette.blue,
        [OrderAssetAvailability.PartialMatch]: Theme.palette.blue,
        [OrderAssetAvailability.NoMatch]: Theme.palette.neutralTertiary
    }
} as const;

export const getAssetAvailabilityColor = (
    availability: OrderAssetAvailability,
    type: OrderAssetStorageType
): string => {
    return orderAssetAvailabilityColorMaps[type][availability];
};
